/* eslint-disable */
import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import styled from 'styled-components';
import ButtonSecondary from 'components/ButtonSecondary';
import ButtonV2 from 'components/ButtonV2';

const Icon = styled.img``;
import Svg from "_assets/svg";
import Checkbox from 'components/Checkbox';
import CheckboxV2 from 'components/CheckboxV2';
import { Alert, AlertType } from 'utils/Alert';
import FeatherIcon from 'feather-icons-react';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#FFFFFF',
    border: '1px solid #EBECF0',
    boxShadow: '1px 1px 20px rgba(170, 170, 170, 0.2)',
    borderRadius: '10px',
    width: '750px',
    padding: 0
  },
};

function AboutCategories(props) {
  const {isOpenModal,setOpenModal, setModalAddTemplate} = props;

  function closeModal() {
    setModalAddTemplate({show: true, payload: []})
    setOpenModal(false)
  }

  return (
    <Modal
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
    <div className='modal_categories'>
      <div className='d-flex align-items-start justify-content-between wa_title_modal px-4 py-3'>
        <div>
          <h4 className='fsize-20 fweight-600 cl-neutral500'>About Categories</h4>
          <p className='fsize-14 fweight-400 cl-neutral400 mb-0'>Choose a category that describes the text, media and buttons that you will send.</p>
        </div>
        <div className="cursor-pointer" onClick={closeModal}>
          <FeatherIcon icon="x" width={18} height={18} />
        </div>
      </div>
      <div className="body_categories px-4 py-4">
        <div className='row'>
        <div className='col-4'>
            <div className='box'>
              <Icon src={Svg.categories_marketing.default} className="mb-2 w-100" />
              <div className='footer'>
                <div className='d-flex align-items-center mb-2'>
                  <Icon src={Svg.megaphone.default} />
                  <p className='fsize-14 fweight-600 cl-grey-black ms-2 mb-0'>Marketing</p>
                </div>
                <p className='fsize-12 fweight-400 cl-neutral500'>Any message that is not utility or authentication will be marketing.</p>
                <p className='fsize-12 fweight-400 cl-neutral100'>
                  Examples: welcome messages, newsletters, offers, coupons, catalogues, new store hours
                </p>
              </div>
            </div>
          </div>
          <div className='col-4'>
            <div className='box'>
              <Icon src={Svg.categories_utility.default} className="mb-2 w-100" />
              <div className='footer'>
                <div className='d-flex align-items-center mb-2'>
                  <Icon src={Svg.bell.default} />
                  <p className='fsize-14 fweight-600 cl-grey-black ms-2 mb-0'>Utility</p>
                </div>
                <p className='fsize-12 fweight-400 cl-neutral500'>
                  Updates about an order or account that a customer has already created.  
                </p>
                <p className='fsize-12 fweight-400 cl-neutral100'>
                  Examples: order confirmations, account updates, receipts, appointment reminders, billing
                </p>
              </div>
            </div>
          </div>
          <div className='col-4'>
            <div className='box'>
              <Icon src={Svg.categories_authentication.default} className="mb-2 w-100" />
              <div className='footer'>
                <div className='d-flex align-items-center mb-2'>
                  <Icon src={Svg.key_skeleton.default} />
                  <p className='fsize-14 fweight-600 cl-grey-black ms-2 mb-0'>Authentication</p>
                </div>
                <p className='fsize-12 fweight-400 cl-neutral500'>
                  Codes to help customers verify their purchases or account logins.
                </p>
                <p className='fsize-12 fweight-400 cl-neutral100'>
                  Examples: one-time password, account recovery code
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex align-items-center justify-content-end mt-5'>
          {/* <ButtonSecondary
            className
            handleRoute={closeModal}
            backgroundColor="#FFFFFF"
            textColor="#97A0AF"
            padding=".360rem 1rem"
            noBorder
          >Cancel</ButtonSecondary> */}
          <ButtonV2
            className="ms-4"
            handleRoute={closeModal}
            backgroundColor="#3B3B47"
            textColor="#FFFFFF"
            padding=".360rem 1.5rem"
          >
            Back
          </ButtonV2>
        </div>
      </div>      
    </div>
    </Modal>
  )
}

export default AboutCategories